import React, { Component } from 'react';
import { BackgroundJob } from '../../../../domain/job/JobDomain';
import moment from 'moment';
import Icon from '../../../../icons/Icon';
import { customConfirm } from '../../CustomPopupConfirm';
import { ConfirmPopup } from 'primereact/confirmpopup';
import LanguageUtil from '../../../../util/LanguageUtil';

class JobListItem extends Component<Props> {
  render() {
    const { job, download } = this.props;
    return (
      <div className={'flex flex-col gap-y-5 w-full text-xs font-formica rounded '}>
        <ConfirmPopup />
        <div className={'flex'}>{moment(job.timestamp).format('LLL')}</div>
        <div className={'flex justify-between items-center border-[0.5px] w-full rounded'}>
          <div className={'w-1/5 border-r py-5 px-5 hover:cursor-pointer'} onClick={download}>
            <Icon icon={'import'} size={24} />
          </div>
          <div className={'flex flex-col gap-1 w-full px-5 py-5'}>
            <p>{job.type}</p>
            <p className='text-gray-400' style={{ fontSize: 9 }}>
              {moment(job.timestamp).format('LLL')}
              {job.processTime ? ` - ${moment(job.timestamp + job.processTime).format('LLL')}` : ''}
            </p>
          </div>
          <div
            className={'flex px-5 py-5'}
            onClick={(e) => {
              this.deleteJob(e);
            }}
          >
            <Icon icon={'close'} size={24} className={'hover:cursor-pointer'} />
          </div>
        </div>
        <div></div>
      </div>
    );
  }

  private deleteJob(e: any) {
    const { remove } = this.props;
    e.preventDefault();
    customConfirm({
      target: e.currentTarget,
      message: LanguageUtil.get({ id: 'messages.confirm.removeJob', defaultMessage: 'Are you sure remove this job?' }),
      accept: () => remove(),
    });
  }
}

interface Props {
  job: BackgroundJob;
  download: VoidFunction;
  remove: VoidFunction;
}

export default JobListItem;
